export const DatabaseIcon = () => (
  <svg width="0.9em" height="1em" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 5V15C1 17.2091 4.58172 19 9 19C13.4183 19 17 17.2091 17 15V5M1 5C1 7.20914 4.58172 9 9 9C13.4183 9 17 7.20914 17 5M1 5C1 2.79086 4.58172 1 9 1C13.4183 1 17 2.79086 17 5M17 10C17 12.2091 13.4183 14 9 14C4.58172 14 1 12.2091 1 10"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
